import { X } from "lucide-react";
import React from "react";
import ConditionalTooltipWrapper from "../../../helpers/components/ConditionalTooltipWrapper";
import { BaseRemoveButtonButton, BaseRemoveButtonContainer } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
export function RemoveButtonContainer(_ref) {
  var tooltipContent = _ref.tooltipContent,
    children = _ref.children;
  return /*#__PURE__*/_jsx(ConditionalTooltipWrapper, {
    tooltipContent: tooltipContent,
    children: /*#__PURE__*/_jsx(BaseRemoveButtonContainer, {
      children: children
    })
  });
}
function RemoveButton(_ref2) {
  var onClick = _ref2.onClick,
    tooltipContent = _ref2.tooltipContent,
    isDisabled = _ref2.isDisabled;
  return /*#__PURE__*/_jsx(RemoveButtonContainer, {
    tooltipContent: tooltipContent,
    children: /*#__PURE__*/_jsx(BaseRemoveButtonButton, {
      onClick: onClick,
      disabled: isDisabled,
      children: /*#__PURE__*/_jsx(X, {
        color: "currentColor",
        size: "1em"
      })
    })
  });
}
export default RemoveButton;